import postPic1 from "../img/postpic1.webp";
import postPic2 from "../img/postpic2.webp";
import postPic3 from "../img/postpic3.webp";

export const PostsData = [
  {
    id: 1,
    img: postPic1,
    name: "Heize",
    desc: "Today was a good day",
    likes: 4976,
    liked: true,
  },
  {
    id: 2,
    img: postPic2,
    name: "Loona",
    desc: "Chillin...",
    likes: 3847,
    liked: false,
  },
  {
    id: 3,
    img: postPic3,
    name: "Hyuna",
    desc: "What are you up to ?",
    likes: 6493,
    liked: false,
  },
];
